import api, { apiSetup } from '../api';

apiSetup();

export class FinanciadoresEstudiosService {
  BASE_URL = '/financiadores-estudios';

  get() {
    return api.get(this.BASE_URL);
  }
}
